import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { authKeys, RequestTypes } from '@core/react-query/features/auth'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export type SkipMFASessionResponse = {}

export const useSkipMFASession = (
  options?: UseMutationOptions<
    SkipMFASessionResponse,
    RequestErrorType,
    RequestTypes['skipMFASession']
  >,
) => {
  return useMutation({
    ...authKeys.skipMFASession,
    ...options,
  })
}
